import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {AddAPhoto} from "@mui/icons-material";
import {useRef, useState} from "react";
import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import useDocumentRepository from "../../../../../../repository/insurance/useDocumentRepository";
import useAlert from "../../../../../../use/useAlert";
import isNull from "../../../../../../mixin/isNull";
import Compressor from "compressorjs";

export default function ({interventionId}) {
    const alert = useAlert();
    const interventionRepository = useInterventionRepository();
    const documentRepository = useDocumentRepository();
    const pictureInput = useRef();
    const [loading, setLoading] = useState(false);

    const handleTakePictureClick = () => pictureInput.current.click();

    const handleUpload = e => {
        const file = e.target.files[0];

        if (isNull(file)) return;

        setLoading(true);

        new Compressor(file, {
            quality: 0.3,
            success: async compressedBlob => {
                const fileId = await documentRepository.uploadFile(compressedBlob);

                if (isNull(fileId)) {
                    alert.error("Échec de l'upload du document.");
                    setLoading(false);
                    return;
                }

                const res = await interventionRepository.skipQuotationSignature(interventionId, fileId);

                if (!res) setLoading(false);
            },
            error: () => {
                alert.error("Échec de la compression du document.");
                setLoading(false);
            }
        });
    }

    return (
        <>
            <Typography display={"block"} color={"error"}>
                <Typography display={"inline"} fontWeight={"bold"}>
                    Étape 1.&nbsp;
                </Typography>
                Faites un devis papier, en recopiant à la lettre les éléments ci-dessus
            </Typography>
            <Typography variant="caption">
                "Tout manquement aux obligations d'information précontractuelle mentionnées aux 1° à 4°
                et 6° de l'article L. 111-1 et aux articles L. 111-2 et L. 111-3 est passible d'une
                amende administrative dont le montant ne peut excéder 3 000 euros pour une personne
                physique et 15 000 euros pour une personne morale. Cette amende est prononcée dans les
                conditions prévues au chapitre II du titre II du livre V."
            </Typography>

            <Typography display={"block"} color={"error"} mt={5}>
                <Typography display={"inline"} fontWeight={"bold"}>
                    Étape 2.&nbsp;
                </Typography>
                Faites signer le devis papier par le sociétaire
            </Typography>

            <Box mt={5}>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<AddAPhoto/>}
                    fullWidth
                    onClick={handleTakePictureClick}
                    disabled={loading}
                    data-test="insurance-button-upload-quotation"
                >
                    Prenez votre devis en photo
                </Button>
                <input
                    ref={pictureInput}
                    style={{display: "none"}}
                    type={"file"}
                    accept="image/*"
                    onChange={handleUpload}
                    data-test="insurance-input-file"
                />
            </Box>
        </>
    );
}
